// extracted by mini-css-extract-plugin
module.exports = {"backgroundpic":"expensereport_backgroundpic__tmrW-","waitinginfo":"expensereport_waitinginfo__2u9Jy","table":"expensereport_table__1lA6e"};